import clsx from "clsx";
import { DemographicIcon } from "common";
import React from "react";
import { LineItemSelectorType, LineItemTemplate, LineItemType } from "types";
import { xolaUri } from "../../api/xolaUri";

export const ImageSizes = {
    tiny: "w-6 h-6",
    small: "w-10 h-10",
    medium: "w-14 h-14",
    large: "w-16 h-16",
};

export interface LineItemTemplateImageProps {
    lineItemTemplate?: LineItemTemplate;
    type: LineItemSelectorType;
    size?: keyof typeof ImageSizes;
    className?: string;
    classNames?: { image?: string; container?: string };
    style?: any;
}

export const LineItemTemplateImage = ({
    lineItemTemplate,
    type,
    size = "medium",
    className,
    classNames,
    ...rest
}: LineItemTemplateImageProps) => {
    // const xolaSize = size === "tiny" ? "small" : size; // Xola API doesn't support "tiny"

    if (type === LineItemType.EQUIPMENT) {
        return null;
    }
    return (
        <div className={clsx("mr-3 flex-shrink-0 rounded-lg border-[3px] border-transparent", className)} {...rest}>
            {type === LineItemType.DEMOGRAPHIC ? (
                <DemographicIcon name={lineItemTemplate?.name ?? ""} />
            ) : (
                <img
                    src={getDefaultPhotoUrl()}
                    className={clsx(
                        "border border-transparent object-cover",
                        size === "tiny" ? "rounded" : "rounded-md",
                        ImageSizes[size],
                        classNames?.image,
                    )}
                />
            )}
        </div>
    );
};

export const getDefaultPhotoUrl = () => {
    // @TODO return respective image URL based on LineItemTemplate Type after API is available
    return `${xolaUri}/cache/images/placeholder_140x105.jpg`;
};
